module.exports = __webpack_public_path__ + "static/media/Email.738375c6.svg";